import axios from '@/axios'

const api = {
  install: function (Vue) {
    Vue.prototype.$api = axios
  }
}

export default api